var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(-647 -377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8744",
    "data-name": "Group 8744",
    transform: "translate(647 377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "art"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8743",
    "data-name": "Group 8743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    transform: "translate(5.412 14.25) rotate(-45)",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.154
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.249,
    cy: 6.249,
    r: 5.672,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_14421",
    "data-name": "Line 14421",
    x2: 3.875,
    y2: 3.875,
    transform: "translate(18.625 18.625)",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.154
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cf6e1711b0a4d7d145b851dffc8c0066.svg";
export { ForwardRef as ReactComponent };